import * as yup from 'yup';
import docs from './attachments';
import {
  aceite,
  declaracaoTipoRegime,
  tipoRegime,
  abatimentoDoEmprestimoCondicional,
  acessoContraCheque,
  // acessoJornalForluz,
  adiantamentoQuinzenal,
  consentimentoDescontoFolha,
  consentimentoDadosSensiveis,
  estaAposentadoINSS,
  foiJulgado,
  houveProcessoJudicial,
  parcelaAVista,
  retiradaAVistaMAT,
  aceiteInss,
  consentimentoAjustePagamento,
  declaracaoVeracidade,
  boletoEmprestimoDinamico,
} from './utils/rulesByKey';

export const ResgateMATCEI2018Schema = (saldoDevedor, limiteMaximoRetirada) => {
  const baseSchema = {
    percentualRetiradaMensal: yup
      .number()
      .float(2, 'Máximo de duas casas após a virgula')
      .min(0.1, 'Valor deve estar entre 0.10 e 1')
      .max(1, 'Valor deve estar entre 0.10 e 1')
      .required('Atenção, Preencha o Percentual de retirada mensal'),

    consentimentoBeneficio: yup
      .bool()
      .oneOf([true])
      .required('Atenção, Clique em Consentir'),

    ...parcelaAVista,
    ...retiradaAVistaMAT(limiteMaximoRetirada),
    ...boletoEmprestimoDinamico(saldoDevedor),
    ...abatimentoDoEmprestimoCondicional,

    ...consentimentoDadosSensiveis(),
    ...estaAposentadoINSS,
    ...houveProcessoJudicial,
    ...foiJulgado(true),
    ...acessoContraCheque,
    // ...acessoJornalForluz,
    ...adiantamentoQuinzenal,
    ...consentimentoDescontoFolha,
    ...docs.ResgateMATCEI2018Docs.rules,
    ...aceiteInss,
    ...declaracaoTipoRegime,
    ...aceite,
    ...tipoRegime,
    ...consentimentoAjustePagamento,
    ...declaracaoVeracidade,

    processoJudicial: yup.number().when('houveProcessoJudicial', {
      is: 'Sim',
      then: yup
        .number()
        .required(
          'Atenção! Preencha o número do processo que originou a aposentadoria.'
        ),
    }),
  };

  return yup.object(baseSchema);
};

export const ResgateMATCEI2018InitialValues = {
  percentualRetiradaMensal: '',
  consentimentoBeneficio: false,
  parcelaAVista: '',
  retiradaAVista: '',
  consentimentoDadosSensiveis: false,
  estaAposentadoINSS: '',
  houveProcessoJudicial: '',
  processoJudicial: '',
  foiJulgado: '',
  acessoContraCheque: '',
  acessoJornalForluz: '',
  adiantamentoQuinzenal: '',
  consentimentoDescontoFolha: false,
  aceiteInss: false,
  boletoEmprestimo: '',
  abatimentoDoEmprestimo: '',
  aceite: '',
  tipoRegime: '',
  declaracaoTipoRegime: false,
  consentimentoAjustePagamento: false,
  declaracaoVeracidade: false,
  ...docs.ResgateMATCEI2018Docs.initialValues,
};

export const ResgateMATCEI2018Docs = {
  ...docs.ResgateMATCEI2018Docs.docs,
};
